// src/constants/practiceAreas.js
import API_BASE_URL from "../config";

/* ======================
   FETCH PRACTICE AREAS
   (PUBLIC API)
====================== */
export const getPracticeCategories = async () => {
  try {
    const res = await fetch(
      `${API_BASE_URL}/api/practice-areas/public`
    );
    const json = await res.json();

    /*
      Expected API response:
      {
        success: true,
        data: {
          "Personal / Family": [...],
          "Criminal / Property": [...]
        }
      }
    */

    return json?.data || {};
  } catch (error) {
    console.error("Failed to load practice areas", error);
    return {};
  }
};
